//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ugmath.js";
let d=[[[0,"AngleTolerance",1,0],[0,"DistanceTolerance",1,0],[0,"FirstLimitPoint",1,0],[0,"LastLimitPoint",1,0],[0,"OffsetDistance",1,0],[0,"ReferenceFeature",1,"Features.Feature",0],[0,"ReferencePoint",1,0],[0,"SmoothTolerance",1,0],[0,"SmoothType",1,0],[0,"TrimCurveCreateType",1,0],[0,"TrimCurveType",1,0],[0,"TrimOutputCurveType",1,0]],[[["num_curves"],"CreateNonAssociative",{R_:{curves:"ICurve[]"}},0,0]],[]];
SPLM.Die.OutputCurvesBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.OutputCurvesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.OutputCurvesBuilder.SmoothTypes = Object.freeze({
    "None" : "None", "Cubic" : "Cubic", "Quintic" : "Quintic"});

SPLM.Die.OutputCurvesBuilder.TrimCurveTypes = Object.freeze({
    "Trim" : "Trim", "Extended" : "Extended", "None" : "None"});

SPLM.Die.OutputCurvesBuilder.TrimOutputCurveTypes = Object.freeze({
    "Geometric" : "Geometric", "Corrected" : "Corrected", "Both" : "Both"});

SPLM.Die.OutputCurvesBuilder.TrimCurveCreateTypes = Object.freeze({
    "Section" : "Section", "Surface" : "Surface"});

export default SPLM;